/**
 * Creates a default context object where each property throws an error when accessed.
 * Use this to ensure that the context is only accessed within the <Context.Provider>.
 * NOTE: Do not use this if you have a complete default value for the context.
 */
export function getThrowingDefaultContextValue<T extends Record<string, any>>(
  errorMessage: string,
): T {
  return new Proxy({} as T, {
    get() {
      throw new Error(errorMessage);
    },
  });
}
